/** KISS **/

$(document).ready(function(){

  //Delete mobile form if not on mobile to avoid issues
  if(window.innerWidth >= 1070){
    document.getElementById('FacetFiltersFormMobile').remove();
  }
  
  executeCustomisations();
});

window.addEventListener('popstate', function (event) {
	executeCustomisations();
});

function executeCustomisations(){

//Replace Basic Colors filter to Colors  
if($("#FacetFiltersForm .thb-filter-title:contains('Basic Colors')").length > 0){
  $("#FacetFiltersForm .thb-filter-title:contains('Basic Colors')").html($("#FacetFiltersForm .thb-filter-title:contains('Basic Colors')").html().split("Basic Colors").join("Colors"));
}

//Change content ul class for desktop
$colorsList = $("#FacetFiltersForm .thb-filter-title:contains('Colors')").next().find(".list-basic-colors");
$colorsList.attr("class","list-color");

$colorsList.find("li").each(function(index, element){
  let colorString = $(element).find("input").val();
  $(element).find("label").css("--option-color-image","url('https://cdn.shopify.com/s/files/1/0667/0431/0583/files/" + colorString + ".png?v=1670095555')");
});


if($("#FacetFiltersFormMobile .thb-filter-title:contains('Basic Colors')").length > 0){
  $("#FacetFiltersFormMobile .thb-filter-title:contains('Basic Colors')").html($("#FacetFiltersFormMobile .thb-filter-title:contains('Basic Colors')").html().split("Basic Colors").join("Colors"));
}
  
//Change content ul class for mobile
$colorsListMobile = $("#FacetFiltersFormMobile .thb-filter-title:contains('Colors')").next().find("ul");
$colorsListMobile.attr("class","list-color");

$colorsListMobile.find("li").each(function(index, element){
  let colorString = $(element).find("input").val();
  $(element).find("label").css("--option-color-image","url('https://cdn.shopify.com/s/files/1/0667/0431/0583/files/" + colorString + ".png?v=1670095555')");
});
  
}